import React from "react";

function Financial3() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        fill="#1C64F2"
        d="M10.997 8.068l-.76.65a1 1 0 001.52 0l-.76-.65zM6.632 11.78l.79-.613-.79.613zm8.73 0l-.79-.613.79.613zm-5.408 3.29l.671-.741-.67.741zm.753.552l.29-.957-.29.957zm1.332-.552l-.671-.741.67.741zm-.752.552l.29.957-.29-.957zM20 11a9 9 0 01-9 9v2c6.075 0 11-4.925 11-11h-2zm-9 9a9 9 0 01-9-9H0c0 6.075 4.925 11 11 11v-2zm-9-9a9 9 0 019-9V0C4.925 0 0 4.925 0 11h2zm9-9a9 9 0 019 9h2c0-6.075-4.925-11-11-11v2zm.757 5.418c-1.294-1.513-3.585-2.013-5.33-.523l1.3 1.52c.761-.65 1.804-.522 2.51.303l1.52-1.3zm-5.33-.523c-1.654 1.413-1.9 3.807-.584 5.499l1.579-1.227c-.653-.84-.546-2.025.305-2.752l-1.3-1.52zm9.724 5.499c1.306-1.681 1.104-4.095-.596-5.508l-1.278 1.538c.848.705.956 1.892.294 2.743l1.58 1.227zm-.596-5.508c-1.755-1.459-4.017-.99-5.318.532l1.52 1.3c.697-.816 1.727-.953 2.52-.294l1.278-1.538zm-9.712 5.508c.695.895 2.385 2.463 3.44 3.418l1.342-1.483c-1.102-.998-2.639-2.436-3.203-3.162l-1.58 1.227zm6.867 3.418c1.055-.955 2.745-2.523 3.44-3.418l-1.579-1.227c-.564.726-2.1 2.164-3.203 3.162l1.342 1.483zm-3.427 0c.168.151.337.305.493.425.17.13.376.262.64.342l.58-1.914c.05.015.06.033-.004-.015a6.97 6.97 0 01-.367-.321l-1.342 1.483zm2.085-1.483c-.191.173-.29.262-.367.32-.064.05-.054.031-.004.016l.58 1.914c.264-.08.47-.212.64-.342.156-.12.326-.274.493-.425l-1.342-1.483zm-.951 2.25c.373.113.786.113 1.16 0l-.58-1.914-.58 1.914z"
      ></path>
    </svg>
  );
}

export default Financial3;
